<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>申请发票</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="./images/ty_close.png" alt='版权登记'/>
            </div>
            <p class="modal-title">选择订单</p>
            <Row class="invice-table-title">
                <i-col span="6">产品信息</i-col>
                <i-col span="6">支付方式</i-col>
                <i-col span="6">支付时间</i-col>
                <i-col span="6">支付金额</i-col>
            </Row>
            <div  v-if="records.length>0">
                <div style="height:304px;">
                    <Row class="invice-table-content" v-for="(item,index) in records" :key="index">
                        <!-- <i-col span="8"><Checkbox :item='item' :checked='item.checked' @on-change="selectData(item,$event)"></Checkbox>{{item.remarks}}</i-col> -->
                    <i-col span="6" class="onecol">
                        <img :src="currentIndex==index?yes:no" class="imgbox" @click="selectItem(index,item.id)" alt='版权登记'/>
                        <Tooltip style="margin: 0" :content="item.remarks" placement="bottom">
                            <div style="margin:0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:100px;">
                                {{ item.remarks }}
                            </div>
                        </Tooltip>
                    </i-col>
                        <i-col span="6">
                            <span v-if="item.payWay=='AliPay'">支付宝</span>
                            <span v-if="item.payWay=='WechatPay'">微信</span>
                            <span v-if="item.payWay=='APPLEPAY'">IOS内购</span>
                            <span v-if="item.payWay=='RedEnvelope'">红包</span>
                            <span v-if="item.payWay=='Ewallet'">余额支付</span>
                            <span v-if="item.payWay=='Free'">免费</span>
                            <span v-if="item.payWay=='Vip'">VIP特权</span>
                            <span v-if="item.payWay=='Give'">赠送</span>
                            <span v-if="item.payWay=='mixed'">混合支付</span>
                        </i-col>
                        <i-col span="6">{{item.payDate}}</i-col>
                        <i-col span="6">{{item.payAmount}}</i-col>
                    </Row>
                </div>
                <div class="commont-page">
                    <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div> 
                <div style="text-align:center;margin-top:35px;"> 
                    <button class="getBtn" @click="applyBill" :disabled="applyBillFlag">申领 </button>
                </div>   
            </div>            
            <div class="empty-box" v-if="records.length<=0&&flag" style="margin-left:150px;">
                <img src="./images/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>              
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { _getAvailable,_saveBill } from "@/api/wallet.js";
    export default {
        name:'invoicing',
        props:{
            mywidth:{
                type:String,
                default:'600'
            },
            myheight:{
                type:String,
                default:'576'
            },
            myTitleheight:{
                type:String,
                default:'63'
            },
            tishihide:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return{
                total:0,
                pages:0,
                pageNumber:1,
                pageSize:5,
                records:[],
                flag:false,
                recordList:[],
                billId:'',
                currentIndex:null,
                yes: require('./images/yes.png'),
                no:require("./images/no.png"),
                applyBillFlag:false //申请按钮多次点击
            }
        },
        methods:{
            parentHandleclick() {
               this.$emit('fatherModal');
            },  
            //获取列表
            getAvailable(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data={
                    pageNumber:this.pageNumber,
                    pageSize:this.pageSize,
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    isReceipt:0
                }
                _getAvailable(data).then(res => {
                    if(res.code==200){
                        this.total=Number(res.result.total);
                        this.pages=res.result.pages;
                        this.records=res.result.records;
                        this.flag=true;
                    }                                        
                });
            },
            //分页
            changepage(index){
                this.pageNumber = index;
                this.currentIndex=null
                this.billId=""
                this.getAvailable()
            }, 
            //多选
            selectData(target,flag) {
                let _this = this;
                let selectRecordId ='';
                const recordListSelect = target; 
                const currentRecordList = this.records.map(item => item.id === recordListSelect.id ? {...recordListSelect,checked:flag}:item)
                this.records=currentRecordList
                const currentIdList = this.records.filter(item => item.checked)
                 if (currentIdList.length>0){
                    currentIdList.map((item, index) => {
                        selectRecordId += item.id + ",";                    
                    })
                }
                this.billId= selectRecordId.substring(0, selectRecordId.length - 1)
                console.log(this.billId)
            },
            //单选
            selectItem(index,id){
                this.currentIndex=index
                this.billId=id
            },
            //申请发票
            applyBill(){
                this.applyBillFlag = true;
                if(this.billId){
                    let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                    const val={
                        tradeIds:this.billId,
                        registerId:userInfo && userInfo.id?userInfo.id:'',
                        orderContent:""
                    }
                    _saveBill(val).then(res=>{
                        if(res.code==200){
                            this.$emit('updateBillData');
                            this.$emit('fatherModal');
                            toast("申领成功")
                            this.applyBillFlag = false;
                        }else{
                            toast(res.message)
                            this.applyBillFlag = false;
                        }
                    })
                }else{
                    toast("请先选择订单")
                    this.applyBillFlag = false;
                }
            }
        },
        mounted(){
           this.getAvailable() 
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .modal-title{
                margin:15px 0 9px 20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                text-align: left;
            }
            .invice-table-title{
                width:559px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:rgba(251,251,251,1);
                margin:0 20px;
            }
            .invice-table-content{
                width: 559px;margin: 0 auto;
                font-size:14px;
                font-weight:400;
                color:rgba(153,153,153,1);
                border-bottom: 1px solid #EEEEEE;
                div{
                    margin:15px 0;
                    /*width:200px;*/
                    height: 20px;
                    line-height: 1;
                    /*overflow: hidden;*/
                    /*text-overflow: ellipsis;*/
                    /*white-space: nowrap;*/
                }
                .onecol{
                    text-align: left;
                    padding-left: 10px;
                }
                .imgbox{
                    width: 12px;
                    height: 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    vertical-align: super;
                }
            }
            .getBtn{
                width:124px;
                height:42px;
                line-height: 42px;
                border:0;
                background:rgba(255,216,0,1);
                border-radius:4px;
                text-align: center;
                outline: none;
                font-size:14px;
                font-weight:400;
                color:rgba(25,25,25,1);
                cursor: pointer;
            }
        }
    }
</style>